import { Card, Col, Row, Tab, Nav, Button } from "react-bootstrap";
import StorePriceGroup from "./StorePriceGroup";
import StockPriceGroup from "./StockPriceGroup";
import { Title } from "components";
import { RootState } from "redux/store";
import Department from "./DepartmentPriceGroup";
import { useEffect, useState } from "react";
import { showToast } from "redux/slices/Toasts";
import { useDisplayError } from "helpers/Functions";
import { getPriceGroups } from "redux/slices/PriceGroups";
import { useAppSelector, useAppDispatch } from "redux/hooks";
import { applyPriceGroupsStore, updateAssignPriceGroupField } from "redux/slices/AssignPriceGroup";

export function AssignPriceGroup() {
    const dispatch = useAppDispatch();
    const displayError = useDisplayError();
    const [loading, setLoading] = useState(false);
    const [displayStocks, setDisplayStocks] = useState(false);
    const stores = useAppSelector((state: RootState) => state.stores);
    const [displayDepartments, setDisplayDepartments] = useState(false);
    const assignPriceGroup = useAppSelector((state: any) => state.assignPriceGroup);

    useEffect(() => {
        dispatch(getPriceGroups());
        dispatch(updateAssignPriceGroupField({ key: "activeTab", value: 1 }));
    }, []);

    useEffect(() => {
        assignPriceGroup.activeTab === 2 && setDisplayDepartments(true);
        assignPriceGroup.activeTab === 3 && setDisplayStocks(true);
        if (assignPriceGroup.stores.length === 0) dispatch(updateAssignPriceGroupField({ key: "activeTab", value: 1 }));
    }, [assignPriceGroup.activeTab]);

    useEffect(() => {
        if (assignPriceGroup.error) dispatch(showToast({ value: [assignPriceGroup.error] }));
    }, [assignPriceGroup.error]);

    function updateActiveTab(tap: string) {
        dispatch(updateAssignPriceGroupField({ key: "activeTab", value: parseInt(tap) }))
    }

    return (
        <>
            <Title pageTitle="Assign Price Group" />
            <Row>
                <Col xs={12}>
                    <Card>
                        <Card.Body>
                            <Row className="mb-1">
                                <div className="page-container">
                                    <Row className="pt-1 p-0 m-0">
                                        <Tab.Container defaultActiveKey="1" activeKey={assignPriceGroup.activeTab.toString()} onSelect={(tap) => tap && updateActiveTab(tap)}>
                                            <Row className="mb-1 pe-0 me-0">
                                                <Nav id="stocks-nav" as="ul" variant="pills" className="nav nav-pills bg-nav-pills nav-justified mb-3">
                                                    <Nav.Item as="li" className="nav-item">
                                                        <Nav.Link href="#" eventKey="1" className="nav-link rounded-0" >Store Level</Nav.Link>
                                                    </Nav.Item>
                                                    <Nav.Item as="li">
                                                        <Nav.Link disabled={assignPriceGroup?.stores?.length > 0 ? false : true} href="#" eventKey="2" className="nav-link rounded-0"
                                                            onClick={() => setDisplayDepartments(true)}
                                                        >Department Level</Nav.Link>
                                                    </Nav.Item>
                                                    <Nav.Item as="li">
                                                        <Nav.Link disabled={assignPriceGroup.stores.length > 0 ? false : true} href="#" eventKey="3" className="nav-link rounded-0"
                                                            onClick={() => setDisplayStocks(true)}
                                                        >Stock Level</Nav.Link>
                                                    </Nav.Item>
                                                </Nav>
                                                <Tab.Content className="ps-0 pe-0">
                                                    <Tab.Pane eventKey="1">
                                                        <StorePriceGroup updateTab={(tap) => tap && updateActiveTab(tap)} />
                                                    </Tab.Pane>
                                                    <Tab.Pane eventKey="2">
                                                        <Department display={displayDepartments} updateTab={(tap) => tap && updateActiveTab(tap)} />
                                                    </Tab.Pane>
                                                    <Tab.Pane eventKey="3">
                                                        <StockPriceGroup display={displayStocks} updateTab={(tap) => tap && updateActiveTab(tap)} />
                                                    </Tab.Pane>
                                                </Tab.Content>
                                            </Row>
                                        </Tab.Container>
                                    </Row>
                                </div>
                            </Row>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </>
    );
}